import queryString from 'query-string';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import ReactPaginate from 'react-paginate';
import { NumberParam, useQueryParam, withDefault, ArrayParam } from 'use-query-params';
import Content from './PartnerProjectsAllListingContent';
const scrollToRef = (ref) => {
    if (ref.current != null) {
        window.scrollTo(0, ref.current.offsetTop - 230);
    }
};
const PartnerProjectsAllListing = () => {
    const [selectedPage = 1, onSelectPage] = useQueryParam('page', withDefault(NumberParam, 1));
    const [selectedTopicsFilters] = useQueryParam('topics', withDefault(ArrayParam, []));
    const [selectedFilters] = useQueryParam('industries', withDefault(ArrayParam, []));
    const [dataLoading, dataLoaded] = useState(false);
    const [data, setData] = useState(null);
    // Serialise for comparison check.
    const selectedFilterJson = JSON.stringify(selectedFilters);
    const selectedTopicsFilterJson = JSON.stringify(selectedTopicsFilters);
    const myRef = useRef(null);
    const executeScroll = () => scrollToRef(myRef);
    useEffect(() => {
        getData();
        async function getData() {
            const query = {
                page: selectedPage,
                topics: selectedTopicsFilters && [...selectedTopicsFilters],
                industries: selectedFilters && [...selectedFilters],
            };
            dataLoaded(true);
            const res = await fetch(`/api/partnerproject/all/load/?${queryString.stringify(query)}`);
            if (!res.ok) {
                return;
            }
            const resData = (await res.json());
            setData(resData);
            dataLoaded(false);
        }
    }, [selectedFilterJson, selectedTopicsFilterJson, selectedPage]);
    if (!data) {
        if (dataLoading === true) {
            return (React.createElement("div", { className: "site-wide vert-padding-100 loading-spinner" },
                React.createElement("svg", { x: "0px", y: "0px", viewBox: "0 0 135.4 110" },
                    React.createElement("g", { transform: "translate(1.404 1.407)" },
                        React.createElement("circle", { cx: "17.9", cy: "17.9", r: "19.3", fill: "#f05a22" }),
                        React.createElement("circle", { cx: "66.9", cy: "54.1", r: "18.7", fill: "#f05a22" }),
                        React.createElement("circle", { cx: "115.3", cy: "89.9", r: "18.7", fill: "#f05a22" })))));
        }
        return null;
    }
    // The number means number of cards per page
    const totalPages = Math.ceil(data.totalResults / 12);
    return (React.createElement(Fragment, null,
        data.items.length > 0 ? (React.createElement("section", { className: `site-wide js-projects` },
            React.createElement("div", { className: `grid-container grid-container--full` },
                React.createElement("div", { className: "grid-column" },
                    React.createElement("div", { className: `grid-container grid-container--third`, ref: myRef },
                        React.createElement(Content, { items: data.items })))))) : null,
        totalPages > 1 && (React.createElement("section", { className: "pagination" },
            React.createElement(ReactPaginate, { previousLabel: React.createElement("svg", { className: "icon-svg icon-chevron-down" },
                    React.createElement("use", { xlinkHref: "/src/img/svg/icon-chevron-down.svg#icon-chevron-down" })), nextLabel: React.createElement("svg", { className: "icon-svg icon-chevron-down" },
                    React.createElement("use", { xlinkHref: "/src/img/svg/icon-chevron-down.svg#icon-chevron-down" })), breakLabel: "...", breakClassName: "pagination__dots", pageCount: totalPages, marginPagesDisplayed: 2, pageRangeDisplayed: 5, onPageChange: (event) => {
                    onSelectPage(event.selected + 1, 'pushIn');
                    executeScroll();
                }, activeClassName: "pagination--active" })))));
};
export default PartnerProjectsAllListing;
